import { supportsBackgroundProcessors } from '@livekit/track-processors';
var cachedSupport = null;
/**
 * LiveKit's supportsBackgroundProcessors() creates a temporary WebGL2 context
 * on every call. Cache once — otherwise Meet re-renders exhaust the browser
 * WebGL context limit ("too many active WebGL contexts").
 */
export function getSupportsBackgroundProcessors() {
    if (typeof window === 'undefined') {
        return false;
    }
    if (cachedSupport === null) {
        cachedSupport = supportsBackgroundProcessors();
    }
    return cachedSupport;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0U3VwcG9ydHNCYWNrZ3JvdW5kUHJvY2Vzc29ycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9ob29rcy9nZXRTdXBwb3J0c0JhY2tncm91bmRQcm9jZXNzb3JzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSw0QkFBNEIsRUFBRSxNQUFNLDJCQUEyQixDQUFDO0FBRXpFLElBQUksYUFBYSxHQUFtQixJQUFJLENBQUM7QUFFekM7Ozs7R0FJRztBQUNILE1BQU0sVUFBVSwrQkFBK0I7SUFDN0MsSUFBSSxPQUFPLE1BQU0sS0FBSyxXQUFXLEVBQUUsQ0FBQztRQUNsQyxPQUFPLEtBQUssQ0FBQztJQUNmLENBQUM7SUFFRCxJQUFJLGFBQWEsS0FBSyxJQUFJLEVBQUUsQ0FBQztRQUMzQixhQUFhLEdBQUcsNEJBQTRCLEVBQUUsQ0FBQztJQUNqRCxDQUFDO0lBRUQsT0FBTyxhQUFhLENBQUM7QUFDdkIsQ0FBQyJ9